import { BillingSheet } from '../billing/BillingSheet';
import type { BillingDocument, BillingLineItem } from '../../services/billing/billingService';
import type { NovaSheet } from '../../services/assistant/novaLoop';
import type { NovaKind } from '../../services/assistant/novaSession';

function todayISO(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

function emptyDoc(kind: NovaKind): BillingDocument {
  const issue = todayISO();
  return {
    doc_type: kind,
    client_contact_id: null,
    issue_date: issue,
    due_date: issue,
    vat_rate: 20,
    notes: null,
    ht_total: 0,
    vat_total: 0,
    ttc_total: 0,
    number: null,
  } as BillingDocument;
}

export function NovaPaper({ kind, sheet }: { kind: NovaKind | null; sheet: NovaSheet | null }) {
  if (!kind) return null;
  const doc = sheet?.doc ?? emptyDoc(kind);
  const lines = sheet?.lines ?? ([] as BillingLineItem[]);
  return (
    <div className="mx-auto w-full max-w-[210mm]">
      <BillingSheet doc={doc} lines={lines} dossierLabel={sheet?.dossierLabel} />
    </div>
  );
}
